import React, { Fragment, useState } from 'react'
import { flatMap, titleize } from 'lodash'
import { Offcanvas } from 'react-bootstrap'
import PropTypes from 'prop-types'
import Table from 'UI/Table'

import { deviceColumns, customerColumns } from './Columns'
import { Filters, defaultFilters } from './Filters'
import filteredVMData from './Data'

const OffCanvasTitle = (device) => device ? device.name : 'Device Compliance'
const ManagedServiceIntegrationCoverage = ({ devices = [] }) => {
  const [filters, changeFilters] = useState(defaultFilters)
  const [moreDetails, showMoreDetails] = useState({ show: false, device: null })
  const data = filteredVMData({ devices, filters })

  const tableData = {
    data,
    columns: customerColumns(),
    className: 'table',
    defaultSorted: [{ id: 'customer_name', asc: true }],
    collapseOnDataChange: true,
    collapseOnSortingChange: true,
    collapseOnPageChange: true,
    SubComponent: (row) => (
      <Table
        filterable
        data={row.original.devices}
        columns={deviceColumns({ showMoreDetails })}
        collapseOnDataChange
        collapseOnSortingChange
        collapseOnPageChange
      />
    )
  }

  return (
    <Fragment>
      <Offcanvas placement='end' show={moreDetails.show} onHide={() => showMoreDetails({ show: false, device: null })}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title as='h2'>{OffCanvasTitle(moreDetails.device)}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {moreDetails.device && (
            <Fragment>
              <h6>Antivirus</h6>
              <ul>
                <li>Product: {moreDetails.device.antivirus_product}</li>
                <li>Status: {titleize(moreDetails.device.antivirus_status)}</li>
              </ul>

              <h6>Patching</h6>
              <ul>
                <li>Status: {titleize(moreDetails.device.patching_status)}</li>
                <li>Patches Pending: {moreDetails.device.patches_approved_pending}</li>
              </ul>
            </Fragment>
          )}
        </Offcanvas.Body>
      </Offcanvas>

      <Filters {...{ filters, changeFilters, devices: flatMap(devices, 'devices') }} />

      <Table {...tableData} />
    </Fragment>
  )
}

export default ManagedServiceIntegrationCoverage
